import React from "react";

import { QRFRameProps } from "../types";

import { getPreviewFrameFontSize } from "@/utils/qrEditorHelper";
import "../styles.scss";

export const wineFrame = (
  props: Omit<QRFRameProps, "frameType">
): React.SVGProps<SVGSVGElement> => {
  const { text, textColor, children, frameColor, frameBackgroundColor, urlQr } = props;

  const fontSize = getPreviewFrameFontSize(text?.length);

  return (
    <svg
      width="96"
      height="128"
      viewBox="0 0 96 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        fill="white"
      />
      <rect
        x="0.5"
        y="0.5"
        width="95"
        height="127"
        rx="7.5"
        stroke="#BFBFBF"
      />
      <path
        d="M15.5 39.2702C15.5 38.495 15.948 37.7896 16.6497 37.46L47.5538 22.9444C48.1465 22.666 48.8381 22.6954 49.405 23.0232L79.501 40.4225C80.1192 40.7799 80.5 41.4398 80.5 42.1539V92C80.5 93.1046 79.6046 94 78.5 94H17.5C16.3954 94 15.5 93.1046 15.5 92V39.2702Z"
        fill={frameBackgroundColor}
      />
      <path
        d="M45.8772 18.0868C43.8229 18.4425 43.1802 18.5917 42.1358 18.936C40.8504 19.3607 38.9912 20.2558 37.8321 21.0018C34.9974 22.8266 32.0938 26.3728 30.9347 29.4026L30.7511 29.8961H23.3946C15.2806 29.8961 15.0741 29.9076 13.6395 30.6192C12.6984 31.0782 11.6311 32.1111 11.1376 33.0637C10.3687 34.5212 10.4146 32.1685 10.4146 65.0259C10.4146 84.6852 10.449 95.0371 10.5294 95.4388C10.5982 95.7831 10.7818 96.3454 10.954 96.6897C11.3327 97.4816 12.6869 98.8473 13.4329 99.1916C14.7986 99.8343 12.5607 99.7884 48.2413 99.7654L81.1676 99.731L81.8562 99.4556C83.2219 98.9047 84.2318 98.0325 84.863 96.8504C85.632 95.4044 85.5861 97.7226 85.5861 65.0718C85.5861 32.5472 85.632 34.8196 84.8975 33.2702C84.2318 31.8931 82.8891 30.7339 81.3512 30.206C80.6052 29.9535 80.479 29.9535 72.87 29.8961L65.1348 29.8388L64.8479 29.1616C64.0331 27.2336 62.3805 24.835 60.7852 23.2742C57.9964 20.5657 55.2535 19.1082 51.3859 18.2933C50.1235 18.0294 46.8986 17.9031 45.8772 18.0868ZM50.6285 25.4088C52.3958 25.8793 53.8304 26.7286 55.265 28.1747C58.3981 31.3307 59.0408 36.3001 56.8258 40.1447C56.5389 40.6382 56.3208 41.1317 56.3438 41.235C56.3782 41.4186 57.0209 41.4301 64.297 41.4989C73.0881 41.5678 73.0651 41.5678 74.6259 42.3367C75.6818 42.8647 76.5884 43.5992 77.3803 44.5517C78.1952 45.5387 78.5968 46.2502 79.01 47.3979L79.3313 48.316L79.3658 70.2363C79.3887 87.497 79.3658 92.2139 79.251 92.4204C78.9182 93.0517 80.984 93.0172 47.9085 93.0172H17.335L17.0366 92.7418C16.8759 92.5926 16.7037 92.3401 16.6693 92.1909C16.6349 92.0532 16.6234 82.1375 16.6349 70.1789L16.6693 48.4308L16.9218 47.7078C17.2317 46.7896 17.794 45.7223 18.3449 44.9763C19.2401 43.7598 20.996 42.44 22.2928 42.0039C23.7618 41.5104 24.2209 41.4875 31.9331 41.4875C37.1205 41.4875 39.347 41.453 39.4044 41.3612C39.4388 41.2924 39.1863 40.6612 38.8305 39.9611C37.7747 37.8838 37.4304 35.9328 37.7288 33.7867C38.0961 31.1012 39.3011 29.0124 41.5849 27.1532C42.6408 26.281 44.7295 25.4088 46.2329 25.1907C47.3921 25.0301 49.5841 25.1448 50.6285 25.4088Z"
        fill={frameColor}
      />
      <path
        d="M47.1396 30.1486C42.813 30.6077 41.0226 36.082 44.1442 39.284C45.246 40.4087 46.6002 40.8907 48.3447 40.753C50.6744 40.5808 52.6713 38.6872 53.1074 36.2427C53.5435 33.8096 51.9483 31.1471 49.5956 30.3781C48.7119 30.0798 48.184 30.0338 47.1396 30.1486Z"
        fill={frameColor}
      />
      <path
        d="M24.9419 50.3168C22.9415 50.6247 21.2306 51.2141 21.0112 51.6803C20.906 51.9179 20.7568 52.8591 20.1602 57.3983C19.5372 62.0607 19.4671 62.7205 19.5109 63.7761C19.6776 67.6819 22.5028 71.0159 26.4071 71.922L27.2055 72.098L27.2494 72.6434C27.2845 72.9425 27.2669 74.394 27.2318 75.8718C27.1617 78.2822 27.1353 78.5989 26.9774 78.9508C26.6879 79.6017 26.1264 80.2263 25.3981 80.7101C24.6699 81.194 24.8103 81.2204 25.6789 80.7629C26.1702 80.5078 26.7317 80.024 27.188 79.461C27.46 79.1267 27.6881 79.2147 27.6267 79.6193C27.5302 80.1823 26.8984 80.9037 26.0649 81.3875C25.4508 81.7394 24.0645 82.1264 22.9152 82.2496C21.4763 82.4167 20.4146 82.5751 20.2479 82.6543C19.8005 82.8918 19.6074 83.4548 19.897 83.7363C20.0198 83.8682 20.8972 83.877 28.5567 83.8594L37.076 83.833L37.2076 83.6131C37.3129 83.4108 37.3129 83.3492 37.1813 83.0677C37.0936 82.8918 36.962 82.7158 36.883 82.6894C36.804 82.6543 36.0758 82.4959 35.2686 82.3288C31.8293 81.6338 30.3904 80.8245 29.5569 79.1355L29.2761 78.5549L29.2498 75.3528C29.2323 72.8809 29.2498 72.1332 29.3376 72.0804C29.3902 72.0452 29.6446 71.9836 29.8903 71.9484C30.5132 71.8692 31.6801 71.4558 32.3645 71.0775C34.4965 69.8987 36.1021 67.8491 36.7338 65.4563C37.1462 63.9344 37.1287 63.1955 36.5496 58.9378C35.6985 52.5864 35.602 51.9443 35.4178 51.5924C35.2248 51.2229 34.1017 50.7919 32.3996 50.4312C31.6714 50.2816 31.1625 50.2464 28.662 50.2201C26.4773 50.2025 25.5648 50.2289 24.9419 50.3168ZM29.9342 51.8563C31.6363 51.9706 33.4437 52.2785 33.4437 52.4721C33.4437 52.5776 32.3645 52.8063 31.1274 52.9647C29.5657 53.1582 25.8719 53.0879 24.4857 52.8415C23.9329 52.736 23.3626 52.6128 23.2135 52.56C22.9941 52.4721 22.9766 52.4457 23.1082 52.3753C23.3363 52.2433 25.2314 51.953 26.3808 51.8739C27.8548 51.7595 28.4777 51.7595 29.9342 51.8563ZM22.9941 54.2227C24.5558 54.6889 26.6703 54.8912 29.0568 54.8208C30.9168 54.7593 32.1013 54.6097 33.3121 54.2754C33.742 54.1611 34.1017 54.0731 34.1105 54.0819C34.128 54.0907 34.1807 54.4602 34.2333 54.8912C34.286 55.3311 34.4878 56.7738 34.672 58.1021C35.4178 63.4242 35.4353 63.8729 34.9264 65.4299C33.8824 68.6584 30.9432 70.6289 27.6179 70.321C25.9421 70.1626 24.5295 69.4853 23.3012 68.2625C21.9851 66.9606 21.292 65.3156 21.2569 63.4682C21.2394 62.5973 21.2657 62.3246 21.9149 57.4951C22.1255 55.8853 22.301 54.4514 22.301 54.3106C22.301 54.1699 22.3273 54.0555 22.3536 54.0555C22.3887 54.0555 22.6783 54.1347 22.9941 54.2227Z"
        fill={frameColor}
      />
      <path
        d="M23.0034 58.7601C22.9772 58.8648 22.8984 59.4493 22.8196 60.0426C22.7409 60.6447 22.6359 61.5085 22.5746 61.9709C22.4433 62.9656 22.5133 64.0911 22.7671 64.9287C23.0297 65.7576 23.5198 66.5254 24.3074 67.3281C25.7252 68.7677 27.4843 69.3 29.4972 68.8899C30.5649 68.6805 31.4576 68.1832 32.4115 67.2845C32.7441 66.9791 33.2429 66.2462 33.5055 65.6703C34.0743 64.4226 34.1968 63.2797 33.943 61.395C33.7855 60.252 33.7855 60.2259 33.628 59.2312L33.5142 58.5594H23.0559L23.0034 58.7601ZM24.92 60.3567C24.9901 60.3916 25.1126 60.5225 25.1826 60.6534C25.2964 60.8715 25.2964 60.9501 25.1826 61.3165C24.6312 63.1313 25.3576 65.1468 26.8979 66.1153C27.353 66.3945 27.4143 66.4643 27.4143 66.7784C27.4143 67.1013 27.1342 67.3717 26.8017 67.3717C25.8915 67.3717 24.3512 65.7489 23.9049 64.3267C23.5723 63.2448 23.5985 61.744 23.9661 60.8541C24.1587 60.4091 24.535 60.2171 24.92 60.3567Z"
        fill={frameColor}
      />
      <foreignObject
        width="38%"
        height="37px"
        style={{ borderRadius: "3px" }}
        x="40"
        y="49">
        <div
          id="#qrCode"
          style={{
            border: `1px solid ${frameBackgroundColor || "white"}`,
            width: "100%",
            height: "100%",
            boxSizing: "border-box",

            backgroundColor: `${frameBackgroundColor}`,
          }}>
          {urlQr ? (
            <img
              src={urlQr}
              width="100%"
              height="auto"
            />
          ) : (
            children
          )}
        </div>
      </foreignObject>
      <foreignObject
        width="100%"
        height="18px"
        y="98">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          style={{ width: "100%", height: "100%", maxWidth: "100%" }}>
          <text
            x="50%"
            y="11"
            fill={textColor}
            dominantBaseline="middle"
            textAnchor="middle"
            fontFamily="sans-serif"
            fontWeight="bold"
            style={{ fontSize }}>
            {text}
          </text>
        </svg>
      </foreignObject>
    </svg>
  );
};
